import type { VacationRequestsRepositoryT } from "../../domain/ports/vacationRequests.repository";

type GetVacationRequestsParamsT = {
  vacationRequestsRepository: VacationRequestsRepositoryT;
  colaboraInstanceId: string;
  startDate?: string;
  endDate?: string;
  periodTypeId?: string;
};

export const getVacationRequests = async ({
  vacationRequestsRepository,
  colaboraInstanceId,
  startDate,
  endDate,
  periodTypeId,
}: GetVacationRequestsParamsT) => {
  return await vacationRequestsRepository.getVacationRequests(
    colaboraInstanceId,
    { startDate, endDate, periodTypeId },
  );
};
